import React, { useRef } from 'react';

const EntitiesPopup = ({ entities, onClose }) => {
  const textareaRef = useRef(null);

  const handleCopy = () => {
    if (textareaRef.current) {
      textareaRef.current.select();
      document.execCommand('copy');
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.popup}>
        <h3>Entities</h3>
        <textarea
          ref={textareaRef}
          style={styles.textarea}
          readOnly
          value={JSON.stringify(entities, null, 2)}
        />
        <div style={styles.actions}>
          <button onClick={handleCopy}>Copy</button>
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default EntitiesPopup;

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0,
    width: '100%', height: '100%',
    background: 'rgba(0,0,0,0.5)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1000
  },
  popup: {
    background: '#fff',
    padding: '20px',
    borderRadius: '8px',
    width: '900px',
    maxHeight: '95%',
    display: 'flex',
    flexDirection: 'column'
  },
  textarea: {
    width: '100%',
    height: '600px',
    marginBottom: '10px',
    fontFamily: 'monospace',
    fontSize: '14px'
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between'
  }
};
